module.exports = __webpack_public_path__ + "img/run_left.6f3c671c.jpg";